import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'
import Pricing from '../components/Pricing/Pricing.js'

var pf_config = require('../pf_config.json');

class PricingRoute extends Component {

  componentDidMount(){
    window.document.title = "Pricing - Pattycake";
  }

  render(){
    const { user } = this.props;

    return <div className="landing">
      <div className="screen-height-container">
        <div className="shc-background translucent">
          
        </div>
        <div className="shc-content">
          <Header transparent={true}/>
          <div className="container">
            <div className="row row-mega-padded justify-content-center">
              <div className="col-md-6 text-center">
                <h1>Pattycake can grow with you.</h1>
                <p className="lead soft">
                  Whether just you're starting out or at a global firm, we've got a plan for you. No budget at all? We will <strong>always</strong> have a free version.
                </p>
              </div>
            </div>
            <Pricing/>
            <div className="row row-push-down justify-content-center"/>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(PricingRoute);



// WEBPACK FOOTER //
// ./src/routes/PricingRoute.js